import { makeText, setHtml } from '../lib.js';
import { t } from '../localization.js';
import {
  fadeIn,
  fadeInTimeoutMS,
  fadeOut,
  handleFadeInOut,
  isClickOutside,
  isClicked,
  resetClick,
  saveClick,
} from './utils.js';

let hasShownFaceRecoTooltip = false;

export function show(text = t('home-face-reco-tooltip-message')) {
  if (!isClicked('faceRecoBtnClicked')) {
    const element = makeText('.faceReco-tooltip__text');
    setHtml(text, element);

    fadeIn('.faceReco-tooltip');

    document.addEventListener('click', (event) => {
      const selectors = ['.top-panel', '.menu', '#qrr-overlay', '#qrr-container', '#customPopUp'];
      if (isClickOutside(event, selectors)) {
        fadeOut('.faceReco-tooltip');
        if (!hasShownFaceRecoTooltip && !isClicked('uploadPhotoBtnClicked')) {
          setTimeout(() => handleFadeInOut('.ugc-tooltip'), fadeInTimeoutMS);
          hasShownFaceRecoTooltip = true;
        }
      }
    });

    document.querySelector('.add-selfie__btn').addEventListener('click', off);
  }
}

export function off() {
  saveClick('faceRecoBtnClicked');
  fadeOut('.faceReco-tooltip');
}

export function reset() {
  resetClick('faceRecoBtnClicked');
}
